module.exports = __webpack_public_path__ + "static/media/ascom.be7213f0.png";